import React from 'react';
import { IconProps } from '../types';
const MinecraftComparator: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="12" y="1" width="1" height="1" fill="rgba(133, 4, 4, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(101, 2, 2, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(133, 4, 4, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(67, 6, 13, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(149, 117, 70, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(66, 53, 34, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(133, 4, 4, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(101, 2, 2, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(149, 117, 70, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(66, 53, 34, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(133, 4, 4, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(67, 6, 13, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(103, 82, 49, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(55, 42, 23, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(149, 117, 70, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(103, 82, 49, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(103, 82, 49, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(55, 42, 23, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(149, 117, 70, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(66, 53, 34, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(133, 4, 4, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(101, 2, 2, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(187, 192, 183, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(149, 117, 70, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(66, 53, 34, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(133, 4, 4, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(67, 6, 13, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(187, 192, 183, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(103, 82, 49, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(55, 42, 23, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(133, 4, 4, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(133, 4, 4, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(104, 103, 106, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(149, 117, 70, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(103, 82, 49, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(187, 192, 183, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(187, 192, 183, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(67, 6, 13, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(101, 2, 2, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(133, 4, 4, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(101, 2, 2, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(149, 117, 70, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(66, 53, 34, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(104, 103, 106, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(104, 103, 106, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(67, 6, 13, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(67, 6, 13, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(149, 117, 70, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(66, 53, 34, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(104, 103, 106, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(104, 103, 106, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(118, 94, 56, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(55, 42, 23, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(104, 103, 106, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(104, 103, 106, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(164, 167, 161, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(104, 103, 106, 255)" />
</svg>);
export default MinecraftComparator;